export default "__VITE_ASSET__DKyQbiHS__"